import { render, staticRenderFns } from "./CollectTool.vue?vue&type=template&id=ecdbc114&scoped=true"
import script from "./CollectTool.vue?vue&type=script&lang=js"
export * from "./CollectTool.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ecdbc114",
  null
  
)

export default component.exports